import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import {
  formatRegionAddress,
  getCurrentRegion,
  getRegionContactInfo,    
} from "../util/contactRegion";

const ContactInformation = ({ title = "Contact Information" }) => {
  const region = getRegionContactInfo();
  const currentRegion = getCurrentRegion();
  const regionLabel = currentRegion === "usa" ? "For USA" : "For India";

  return (
    <Box sx={{ mt: 5, mb: 5 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 3,
          color: "#0693e3",
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 3,
        }}
      >
        <Paper
        sx={{
          p: 3,
          backgroundColor: "#f8f9fa",
          border: "1px solid #e0e0e0",
        }}
      >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", mb: 2, color: "#FF895D" }}
          >
            {regionLabel}
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>{region.name}</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: "#666" }}>
            {region.title}
          </Typography>
          {region.email && (
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Email:</strong> {region.email}
            </Typography>
          )}
          {region.phone && (
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Phone:</strong> {region.phone}
            </Typography>
          )}
          {region.address && (
            <Typography variant="body2">
              <strong>Address:</strong> {formatRegionAddress(region.address)}
            </Typography>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default ContactInformation;
